<template>
	<div class="store-initialization-container">
		<BaseLoader type="store-loader" />
	</div>
</template>

<script>
	import { mapGetters, mapMutations, mapActions } from 'vuex';
	import localStorageAdapter from '@/utils/LocalStorageAdapter';
	import locationService from '@/services/location.service';
	import allService from '@/services/all.service';
	import storeLoaderMixin from '@Mixin/storeLoaderMixin';
	import menuItemMixin from '@Mixin/menuItemMixin';
	import headerMixin from '@Mixin/headerMixin';
	import { getParam } from "@/utils/helper.functions";
	import { APP_STORE, MENU_ITEMS } from '@/stores/defs';
	import {CART} from '../../stores/defs';

	export default {
		computed: {
			...mapGetters({
				getItem: MENU_ITEMS.GET_ITEM,
			})
		},
		mixins: [
			storeLoaderMixin,
			menuItemMixin,
			headerMixin,
		],
		props: {
			handle: {
				type: String,
				default: '',
			}
		},
		methods: {
			...mapMutations({
				resetStore: 'reset',
			}),
			...mapActions({
				setDebug: APP_STORE.SET_DEBUG,
				clearCart: CART.CLEAR_CART,
			}),
		},
		mounted() {
			const handle = this.handle;
			const itemId = this.$attrs.itemId;
			const itemVanityName = this.$attrs.itemName;

			localStorageAdapter.removeInconsequentialItems();
			this.resetStore();
			const location = locationService.getLocationFromStorage();
			locationService.getLocationFromHandle(handle, (response) => {
				const base = response.base;
				// If we are going to load a new store then we need to clear the cart
				// This is triggered if you change the store via opening a link to a different store
				// If you instead used the store selector then it's handled in storeLoaderMixin
				if(!location || base !== location.id) {
					this.clearCart();
				}
				const forceLoad = true;
				const debug = getParam('debug');
				this.loadAll(base, forceLoad).then(() => {
					if (debug) {
						this.$modal.hide('contentModal');
						this.setDebug(true);
					}
					let route = {
						name: 'home',
						query: {
							...debug && {debug: 1}
						}
					}
					if (itemId) {
						const routeItem = {
							id: itemId,
						}
						route = this.getItemRoute(routeItem);
					} else if (itemVanityName) {
						const item = this.getItem(itemVanityName)
						if (item) {
							route = this.getItemRoute(item);
						}
					}
					this.$router.push(route);
				});
			});
		},
	}
</script>

<style lang="scss" scoped>
	@import 'commonStyle/menuCard';
	.store-initialization-container {
		width: 100vw;
		height: 100vh;
		background-color: $menu_background;
	}
</style>



// WEBPACK FOOTER //
// src/components/store-locator/StoreDeepLink.vue